import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { AlertInputResponse } from '../../../core/interfaces/alert-input';
import { AlertInputService } from './alert-input.service';

import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-alert-input',
	templateUrl: './alert-input.component.html',
	styleUrls: ['./alert-input.component.scss'],
	animations: [
		trigger('openClose', [
			state(
				'closed',
				style({
					visibility: 'hidden'
				})
			),
			transition('open <=> closed', [animate('0.1s ease-in-out')])
		])
	],
	imports: [FormsModule]
})
export class AlertInputComponent {
	alertService = inject(AlertInputService);

	response: AlertInputResponse = {
		text: '',
		checkValue: false,
		btnConfirm: false
	};

	// Alert subscription
	// @autor: Carlos Sánchez Mora
	// @date: 02-08-2022
	constructor() {
		this.alertService.open.subscribe((res) => {
			if (res.checkbox) this.response.checkValue = res.checkbox.value;
		});
	}

	// Close the alert
	// @autor: Carlos Sánchez Mora
	// @date: 02-08-2022
	close(confirm: boolean): any {
		this.response.btnConfirm = confirm;
		if (confirm) {
			// Emit on confirm subject — dialog stays open for loading
			this.alertService.confirm.next({ ...this.response });
			this.response.text = '';
		} else {
			this.alertService.hide(this.response);
			this.response.text = '';
		}
		return;
	}
}
